module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAB5JREFUeNpiYKA5YNTR8W4AMViAuB7GaGSgDwAIMAD9LwItt0tTqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/TCE-AL/tituloPagFdo.png
// module id = vwlZ
// module chunks = 1